// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/api_limits/company_rate_limit_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsApiLimitsCompanyRateLimitDatatable } from "./constants";
import type {
  AppsApiLimitsCompanyRateLimitDatatableParams,
  AppsApiLimitsCompanyRateLimitDatatableResult,
} from "./types";

export const getDataTableAppsApiLimitsCompanyRateLimitDatatable = reactQueryTableFetcherAdapter(
  appsApiLimitsCompanyRateLimitDatatable,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppsApiLimitsCompanyRateLimitDatatableParams
  ): Promise<AppsApiLimitsCompanyRateLimitDatatableResult> => {
    return fetch(
      "/apps/api_limits/company_rate_limit_datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
